module.exports = __webpack_public_path__ + "static/media/sigil-thumb-8-tully.5bb97981.png";